import {HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest} from '@angular/common/http';
import {firstValueFrom, map, Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {AuthService} from './auth.service';

class HasuraHttpHandler implements HttpHandler {

    authSvr = inject(AuthService);

    constructor(private httpHandler: HttpHandler) {
    }

    handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.authSvr.getAccessToken()}`);
        return this.httpHandler.handle(req.clone({url: `${req.url}`, headers}));
    }
}


export class HasuraHttp extends HttpClient {

    constructor(backend: HttpBackend, private subdomain: string) {
        super(new HasuraHttpHandler(backend));
    }

    async select(table: string, fields: string, whereClause: any = {}, orderBy: any = {}, limit: number = null) {
        const query = `query MyQuery($where: ${table}_bool_exp = {}, $order_by: [${table}_order_by!] = {}, $limit: Int = null) {
        ${table}(where: $where, order_by: $order_by, limit: $limit) {
          ${fields}
        }
      }`;
        const data = await this.execute(query, {
            'where': whereClause,
            'order_by': orderBy,
            'limit': limit,
        });
        return data[table];
    }

    async selectOne(table: string, fields: string, whereClause: any = {}) {
        const rows = await this.select(table, fields, whereClause, {}, 1);
        return rows.length > 0 ? rows[0] : null;
    }

    async insert(table: string, objects: any[], returns: any[] = []) {
        let returning = '';
        if (returns.length > 0) {
            returning = `
        returning {
          ${returns.join(' ')}
        }
      `;
        }
        const query = `mutation MyMutation($objects: [${table}_insert_input!] = {}) {
                                  insert_${table}(objects: $objects) {
                                    affected_rows
                                    ${returning}
                                  }
                                }`;
        const data = await this.execute(query, {
            'objects': objects
        });
        return data[`insert_${table}`];
    }

    async upsert(schema: string, table: string, objects: any[], updateColumns: string) {
        const schemaTable = `${schema}_${table}`;
        const query = `mutation MyMutation($objects: [${schemaTable}_insert_input!] = {}) {
                                  insert_${schemaTable}(objects: $objects, , on_conflict: {constraint: ${table}_pkey, update_columns: [${updateColumns}]}) {
                                    affected_rows
                                  }
                                }`;
        const data = await this.execute(query, {
            'objects': objects
        });
        return data[table];
    }

    async updateMany(table: string, updates: any[]) {
        const query = `mutation MyMutation($updates: [${table}_updates!]!){
                                  update_${table}_many(updates: $updates) {
                                    affected_rows
                                  }
                                }`;
        const data = await this.execute(query, {
            'updates': updates
        });
        return data[table];
    }

    async updateByPK(table: string, pk_columns: any, return_field: string[], object: any) {
        const query = `mutation MyMutation($_set: ${table}_set_input!, $pk_columns: ${table}_pk_columns_input!){
                                  update_${table}_by_pk(pk_columns: $pk_columns, _set: $_set) {
                                    ${return_field.join('\n')}
                                  }
                                }`;
        const data = await this.execute(query, {
            'pk_columns': pk_columns,
            '_set': object
        });
        return data[table];
    }

    async execute(query: string, variables: any): Promise<any> {
        const data = {
            'query': query,
            'variables': variables
        };
        return firstValueFrom(super.post(`/${this.subdomain}/graphql`, data).pipe(map((res: any) => {
            if (!!res.errors) {
                const messages = res.errors.map((e: any) => e.message);
                throw Error(messages.join('; '));
            }
            return res?.data;
        })));
    }
}

@Injectable()
export class MosHasura extends HasuraHttp {
    constructor(backend: HttpBackend) {
        super(new HasuraHttpHandler(backend), 'mos-hasura');
    }
}

@Injectable()
export class KlntHasura extends HasuraHttp {
    constructor(backend: HttpBackend) {
        super(new HasuraHttpHandler(backend), 'klnt-hasura');
    }
}
